import { changePasswordHeaderStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordHeader";

changePasswordHeaderStyles.title = {
    variant: "h2",
    as: "h1",
    color: "primary",
};
